import { reactive } from 'vue'

/**
 * Hosted page names by page ID, for the TopBar label and Recent pages. Hosted pages aren't in the config store, so the
 * hosted site and page queries record the names they load; reading `pageName` inside a computed tracks renames.
 */
const names = reactive(new Map<string, string>())

export function rememberPageNames(pages: readonly { id: string; name: string }[]) {
  for (const page of pages) {
    names.set(page.id, page.name)
  }
}

export function pageName(pageId: string): string | undefined {
  return names.get(pageId)
}
